import { useTranslation } from "react-i18next";
import { Modal, ModalProps } from "antd";
import React, {
  forwardRef,
  ReactNode,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

interface CustomModalProps extends ModalProps {
  children?: ReactNode;
  content?: ReactNode;
  getModalStatus?: (value: boolean) => void;
}

const CustomModal = forwardRef(
  (
    {
      children,
      content,
      getModalStatus = () => {
},
      ...props
    }: CustomModalProps,
    ref
  ) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
      getModalStatus(isModalOpen);
    }, [isModalOpen]);

    const showModal = () => {
      setIsModalOpen(true);
    };

    const handleOk = () => {
      setIsModalOpen(false);
    };

    const handleCancel = () => {
      setIsModalOpen(false);
    };

    useImperativeHandle(ref, () => ({
      open: showModal,
      close: handleCancel,
    }));

    return (
      <>
        <div onClick={showModal}>{children}</div>
        <Modal
          title="Basic Modal"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          {...props}
        >
          {content}
        </Modal>
      </>
    );
  }
);

export default CustomModal;
